export enum InputType {
  EnterOnly = 1,
  EnterAndDropdown = 2,
  EnterAndSearch = 3,
  DropdownOnly = 4,
  SearchOnly = 5,
  BarCode = 6,
  ExistingValues = 7,
  AutoIncrement = 8,
  DropdownAndSearch = 9
}
